var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShoppingBagOpen = function SvgIconShoppingBagOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.625a1 1 0 1 0-2 0 4.75 4.75 0 1 0 9.5 0 1 1 0 1 0-2 0 2.75 2.75 0 1 1-5.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.25v13.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 5.25m2 .25v1.75h16V5.5zm16 13V9.25H4v9.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconShoppingBagOpen;